<style>
a, a:hover, a:focus, a:active {
  text-decoration: none;
  color: inherit;
}

fadv-application{
      background-color:  linear-gradient(37.79deg, rgba(58, 58, 58, 0.58) 6.35%, #FFFFFF 86.71%);;
}

#partnerLogoDiv{
  padding-left: 10%;
}

@media screen and (max-width: 1200px) {
  .logo {
    width: 250px;
  }
}

@media screen and (max-width: 992px) {
  .logo {
    width: 200px;
  }
}

@media screen and (max-width: 768px) {
  .logo {
    width: 150px;
  }
}

</style>
<fadv-application #application class="fadv-app" [background]="this.backgroundStyle" [hasHeader]="!hideHeader" [hasFooter]="!hideHeader" theme="c-elements">
  <fadv-header style="padding-left:0px;" class="fadv-website-header">
    <fadv-grid>
      <fadv-grid-row>
        <fadv-grid-col [col]="{ xs: 6, sm: 4, md: 4, lg: 4, xl: 4 }">
          <fadv-box pv="medium">
            <div>
            <img *ngIf="this.showLogo" class="logo" src="/assets/img/logo.svg" [alt]="'First Advantage'" />
          </div>
          </fadv-box>
        </fadv-grid-col>
        <fadv-grid-col [col]="{ xs: 6, sm: 8, md: 8, lg: 8, xl: 8 }">
        <fadv-box pv="medium">
        <div *ngIf="partner" id="partnerLogoDiv" style="border-left: 3px solid black">
          <img class="logo" [src]="partnerLogo"/>
        </div>
        </fadv-box>
      </fadv-grid-col>
        <fadv-grid-col style="margin-top: 35px" *ngIf="showHelpCenter" alignment='right' [ngSwitch]="showHelpCenterText">
          <fadv-typography *ngSwitchCase="true" variant="primary"><a href="https://fadv.com/smallbusiness/support/" target="_new">Help Center</a><fadv-icon library="solid" foreground="primary" name="circle-question"></fadv-icon></fadv-typography>
          <a *ngSwitchCase="false" href="https://fadv.com/smallbusiness/support/" target="_new"><fadv-icon library="solid" foreground="primary" name="circle-question"></fadv-icon></a>
        </fadv-grid-col>
      </fadv-grid-row>
      <fadv-grid-row>
        <fadv-grid-col>
          <!-- subnav router outlet -->
          <router-outlet name="subnav"></router-outlet>
        </fadv-grid-col>
      </fadv-grid-row>
      <fadv-grid-row>
        <fadv-grid-col>
          <alert></alert>
        </fadv-grid-col>
      </fadv-grid-row>
    </fadv-grid>
  </fadv-header>
  <fadv-content>
    <router-outlet></router-outlet>

  </fadv-content>
  <fadv-footer class="fadv-website-header" variant="transparent">
    <fadv-box pv="medium">
      <fadv-grid>
        <fadv-grid-row>
          <fadv-grid-col [offset]="{ sm: 0, md: 0, lg: 2, xl: 1 }" [col]="{xs: 12, sm: 12, md: 11, lg: 2, xl: 2}" alignment="center">
            <fadv-box [pr]="{ xs: 'xx-small'}">
              <fadv-typography variant="neutral" [scale]="300"> <a href="https://fadv.com/privacy-policy/"  target="_new">Privacy Policy</a> </fadv-typography>
            </fadv-box>
          </fadv-grid-col>
          <fadv-grid-col [col]="{xs: 12, sm: 12, md: 11, lg: 2, xl: 2}" alignment="center">
            <fadv-typography variant="neutral" [scale]="300"> <a href="https://fadv.com/legal-privacy-guarantee/"  target="_new">Terms of Use</a> </fadv-typography>
          </fadv-grid-col>
          <fadv-grid-col [col]="{xs: 12, sm: 12, md: 11, lg: 2, xl: 2}" alignment="center">
            <fadv-typography variant="neutral" [scale]="300"> <a href="https://fadv.com/smallbusiness/support/"  target="_new">Help Center</a> </fadv-typography>
          </fadv-grid-col>
          <fadv-grid-col [col]="{xs: 12, sm: 12, md: 11, lg: 2, xl: 2}" alignment="center">
            <fadv-typography variant="neutral" [scale]="300"> <a href="https://fadv.com/"  target="_new">About First Advantage</a></fadv-typography>
          </fadv-grid-col>
          <fadv-grid-col [col]="{xs: 12, sm: 12, md: 11, lg: 2, xl: 2}" alignment="center">
            <fadv-typography variant="neutral" [scale]="300"> 
              <a href="https://fadv.com/candidates/factact/" target="_new">FACT Act Disclosure</a> </fadv-typography>
          </fadv-grid-col>
        </fadv-grid-row>
      </fadv-grid>
    </fadv-box>
  </fadv-footer>
</fadv-application>
